/**
 * Runs `callback` under an exclusive Web Lock shared by all tabs on this origin.
 * Falls back to running the callback immediately when the Web Locks API is unavailable.
 */
export async function withAuthRefreshLock<T>(callback: () => Promise<T>): Promise<T> {
  if (typeof navigator !== 'undefined' && navigator.locks?.request) {
    return navigator.locks.request('bv:auth:refresh-token', callback) as Promise<T>;
  }

  return callback();
}
